/**
 * Una imagen que no carga (un logo borrado del almacenamiento, un enlace caducado) enseñaba el icono roto del
 * navegador o su texto alternativo («Logo») y descuadraba la tarjeta (05-10-2026, revisión en celular). Aquí se
 * cambia, para toda la web, por un recuadro neutro del mismo tamaño: la tarjeta se queda en su sitio.
 */
const RECUADRO =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" fill="#8882"/>' +
      '<path d="M12 27l6-7 4 5 3-3 4 5z" fill="#8886"/><circle cx="25" cy="15" r="2.5" fill="#8886"/></svg>',
  );

export function cubrirImagenesRotas() {
  document.addEventListener(
    'error',
    (e) => {
      const img = e.target;
      // Una sola vez por imagen: si el recuadro también fallara, no se entra en bucle.
      if (!(img instanceof HTMLImageElement) || img.dataset.rota) return;
      img.dataset.rota = '1';
      img.removeAttribute('srcset');
      img.alt = '';
      img.src = RECUADRO;
    },
    true, // los errores de imagen no suben: solo se ven en la fase de captura
  );
}
